import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { DnvBasemap, DnvGisUtility, DnvMapState } from 'dnv-lib';
import {
  WebMapExportOptions, WebMapExtent, WebMapMapOption, PrintService, WebMapSpatialReference, WebMapExport,
  WebMapBaseMap, WebmapBaseMapLayer, WebMapOperationalLayer
} from 'src/app/services';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'dnv-export',
    templateUrl: './dnv-export.component.html',
    styleUrls: ['./dnv-export.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DnvExportComponent implements OnInit {

  @Output() createPdf = new EventEmitter();

  @Input() mapState: DnvMapState;
  @Input() windowWidth: number;
  @Input() windowHeight: number;
  @Output() printEmitter = new EventEmitter<any>();
  @Output() mapTitleEmitter = new EventEmitter<string>();
  @Output() mapSubtitleEmitter = new EventEmitter<string>();
  @Output() mapLegendPositionEmitter = new EventEmitter<string>();
  @Output() mapLegendEnabledEmitter = new EventEmitter<string>();
  @Output() mapBorderEnabledEmitter = new EventEmitter<string>();
  @Output() legendInfoEmitter = new EventEmitter<any>();
  printForm: UntypedFormGroup;

  constructor() {
    this.printForm = new UntypedFormGroup({
      borderCheckbox: new UntypedFormControl(false),
      mapTitle: new UntypedFormControl(''),
      mapSubTitle: new UntypedFormControl(''),
      legendCheckbox: new UntypedFormControl(false),
      legendPosition: new UntypedFormControl('topRight'),
      paperSize: new UntypedFormControl('Letter')
    });
  }

  ngOnInit(): void {
  }

  getPdf(): void {
    this.createPdf.emit();
    /*
    const selectedBasemap: DnvBasemap = this.mapState.basemaps.find(b => b.selected === true);
    const spatialReference = new WebMapSpatialReference();
    spatialReference.wkid = 4326;
    const webmapExport = new WebMapExport();
    webmapExport.exportOptions = new WebMapExportOptions();
    webmapExport.exportOptions.dpi = 96;
    webmapExport.exportOptions.outputSize = [this.windowWidth, this.windowHeight];
    webmapExport.mapOptions = new WebMapMapOption();
    webmapExport.mapOptions.scale = this.gisUtilityService.scaleFromZoom(this.mapState.zoomLevel, this.mapState.resolutions);
    webmapExport.mapOptions.showAttribution = false;
    webmapExport.mapOptions.spatialReference = spatialReference;
    webmapExport.mapOptions.extent = new WebMapExtent();
    webmapExport.mapOptions.extent.spatialReference = spatialReference;
    webmapExport.mapOptions.extent.xmax = this.mapState.extents.southEastBound.lng;
    webmapExport.mapOptions.extent.xmin = this.mapState.extents.northWestBound.lng;
    webmapExport.mapOptions.extent.ymax = this.mapState.extents.northWestBound.lat;
    webmapExport.mapOptions.extent.ymin = this.mapState.extents.southEastBound.lat;
    webmapExport.operationalLayers = [
      new WebMapOperationalLayer()
    ];
    webmapExport.operationalLayers[0].url =
    'https://geotoolsprod.cdnv.dnv.ca:6443/arcgis/rest/services/GeotoolsRedev_Inventory/MapServer/3';
    webmapExport.operationalLayers[0].title = 'Hydroelectric Line';
    webmapExport.operationalLayers[0].opacity = 1;
    webmapExport.operationalLayers[0].visibleLayers = [];
    webmapExport.baseMap = new WebMapBaseMap();
    webmapExport.baseMap.title = selectedBasemap.name;
    webmapExport.baseMap.baseMapLayers = [new WebmapBaseMapLayer()];
    webmapExport.baseMap.baseMapLayers[0].url = selectedBasemap.url;
    webmapExport.baseMap.baseMapLayers[0].opacity = 1;
    console.log(webmapExport);
    this.printService.exportPdf('geotools-map.pdf', webmapExport);
    */
  }

  printMap(mode: string): void {
    this.printEmitter.emit({
      mode,
      paperSize: this.printForm.get('paperSize').value
    });
  }

  emitMapLegendEnable(): void {
    const legendEnabled = this.printForm.get('legendCheckbox').value
    this.mapLegendEnabledEmitter.emit(legendEnabled);
  }

  emitMapBorderEnable(): void {
    const borderEnabled = this.printForm.get('borderCheckbox').value
    this.mapBorderEnabledEmitter.emit(borderEnabled);
    this.clearTitles(borderEnabled);
  }

  emitMapLegendPosition(): void {
    const maplegendPosition = this.printForm.get('legendPosition').value;
    this.mapLegendPositionEmitter.emit(maplegendPosition);
  }
  emitMapTitle(): void {
    const mapTitle = this.printForm.get('mapTitle').value;
    this.mapTitleEmitter.emit(mapTitle);
  }

  emitMapsubTitle(): void {
    const mapSubTitle = this.printForm.get('mapSubTitle').value;
    this.mapSubtitleEmitter.emit(mapSubTitle);
  }

  clearTitles(hasBorder: boolean): void {
    if (!hasBorder) {
      this.printForm.get('mapTitle').setValue('');
      this.printForm.get('mapSubTitle').setValue('');
      this.emitMapTitle();
      this.emitMapsubTitle();
    }
  }
}

